import React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import InlineLoader from '../loaders/InlineLoader'
import { CommonPose } from '../home/Animations'

const Loading = styled.div`
  ${(props) => (props.fullHeight ? 'min-height: 80vh' : 'min-height: 160px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
`

const UserLoaded = inject('store')(
  observer(({ store, children, fullHeight }) => {
    return (
      <div>
        {store.sessionData.profileLoading && (
          <Loading fullHeight={fullHeight}>
            <InlineLoader />
          </Loading>
        )}
        {!store.sessionData.profileLoading && (
          <CommonPose>{children}</CommonPose>
        )}
      </div>
    )
  })
)

export default UserLoaded
